<app-llc [fct]="true" [benefits]="benefits"></app-llc>
